import styled from 'styled-components';

import colors from '../../../../../../styles/colors';

const AttachmentGenericWrapper = styled.div`
  width: 50px;
  height: 50px;
  background-color: ${colors.base.alpha};
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export {
  AttachmentGenericWrapper,
};
